// @ts-nocheck
import styled from '@emotion/styled';
import { Stack, Box, IconButton } from '@mui/material';

export const DropzoneCard = styled(Stack)(({ theme }) => ({
  border: `2px dashed ${theme.palette.primary.dark}`,
  borderRadius: '12px',
  padding: '40px 50px',
  boxSizing: 'border-box',
  maxWidth: '320px',
  backgroundColor: '#F5F5F5',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: '#F7F7F7',
    borderColor: theme.palette.primary.dark,
  },
}));

export const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight: '80vh',
  backgroundColor: 'white',
  color: theme.palette.common.dark,
  padding: theme.spacing(4),
  borderRadius: 16,
  overflowY: 'auto',
  border: `1px solid ${theme.palette.primary.dark}`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const FileList = styled(Box)(({ theme }) => ({
  maxHeight: '200px',
  overflowY: 'auto',
  marginBottom: theme.spacing(2),
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'white',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.primary.dark,
    borderRadius: '4px',
  },
}));

export const FileItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  borderRadius: '8px',
  marginBottom: theme.spacing(1),
  backgroundColor: 'white',
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
}));

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.error.main,
  padding: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: 'rgba(255, 0, 0, 0.1)',
  },
  width: '25px',
  height: '25px',
  flexShrink: 0,
  marginLeft: '12px',
}));
